import { IPageRelationResponseCollection, IStoryRelationResponseCollection } from '@/graphql/__generated__/global/types';
import { I18nLocales } from '@/interfaces/locales.interfaces';
import { findFullSlug } from '@/lib/strapiQueries';
import { determineNextLocale } from './determineLocale';
import { getBaseUrl } from './getBaseUrl';

export const createLanguageAlternates = (canonicalURL: string, localizations?: IPageRelationResponseCollection | IStoryRelationResponseCollection) => {
    const languageAlternates: Array<{ href: string; hrefLang: string }> = [];
    if (!localizations?.data || localizations?.data.length === 0) {
        return languageAlternates;
    }

    const baseUrl = getBaseUrl();

    for (const localization of localizations.data) {
        if (localization?.attributes?.locale) {
            const locale = determineNextLocale(localization?.attributes?.locale as I18nLocales);
            const slug = `${findFullSlug(localization).join('/')}`;
            const fixedSlug = slug === '/' ? '' : slug;

            languageAlternates.push({
                href: `${baseUrl}/${locale}/${fixedSlug}`,
                hrefLang: localization?.attributes?.locale,
            });
        }
    }

    languageAlternates.push({ href: canonicalURL, hrefLang: 'x-default' });

    return languageAlternates;
};
